import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(() =>
  mq({
    width: '100%',
    maxWidth: '840px',
  }),
);

export const Contents = styled.div(() =>
  mq({
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    padding: [
      `${defaultTheme.spacing.xs} ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.xs} ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.s} 64px`,
      `${defaultTheme.spacing.s} 64px`,
    ],
    marginTop: defaultTheme.spacing.xxl,
  }),
);

export const AuthorSelector = styled.div(() =>
  mq({
    width: '100%',
    margin: [
      `${defaultTheme.spacing.m} 0 ${defaultTheme.spacing.s}`,
      `${defaultTheme.spacing.m} 0 ${defaultTheme.spacing.s}`,
      `${defaultTheme.spacing.xxl} 0 ${defaultTheme.spacing.s}`,
      `${defaultTheme.spacing.xxl} 0 ${defaultTheme.spacing.s}`,
    ],
  }),
);

export const ContentEmptyMessage = styled.p(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    color: defaultTheme.text.gray,
    backgroundColor: defaultTheme.background.white,
    padding: '88px 0',
    marginTop: defaultTheme.spacing.xxl,
  }),
);

export const LoadingWrapper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    padding: '88px 0',
    marginTop: defaultTheme.spacing.xxl,
  }),
);
